export default () => m.route.get().includes(app.route('following'));
